@use '../../scss/global' as *;
@use 'themes';

// ================================================================ //
// -- Local Variables

// ================================================================ //
// -- Component Styles

:host {
  display: inline-block;
  vertical-align: middle;

  .fluid-dropdown-button {
    position: relative;
    text-align: left;

    // Since nested FLUID Button must not have margins for alignment purposes,
    // add default button margins back to Dropdown Button
    &.fluid-dropdown-button {
      margin-right: var(--margin-horizontal);
      margin-bottom: var(--margin-vertical);
    }

    // ==== Disabled State

    &.disabled {
      cursor: not-allowed;
    }

    // ==== Remove Margins

    &.no-margin {
      margin-right: 0;
      margin-bottom: 0;
    }

    &.no-vertical-margin {
      margin-top: 0;
      margin-bottom: 0;
    }

    &.no-horizontal-margin {
      margin-left: 0;
      margin-right: 0;
    }
  }
}